import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=419c17a4&scoped=true&"
import script from "./InputItem.vue?vue&type=script&lang=ts&"
export * from "./InputItem.vue?vue&type=script&lang=ts&"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=419c17a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c17a4",
  null
  
)

export default component.exports